import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitOfferingsCatalog = createSelector(
  [selectFinancialCockpitState],
  ({ offeringsCatalog }) => offeringsCatalog
)
